import React, { useEffect } from "react";
import "./JewelleryCopilotPage.css";
import logo from "./jewellery-logo.svg";
import { COPILOT_TOKEN, useKodlyLoader } from "./jewelleryDemo";

// Store copilot of the jewellery demo: the team's chat, docked, inside a store portal. The
// store, its address, hours and stock are real (bluebird.pt, read live); the procedures are
// samples, and the footer says so.
const CONTAINER_ID = "jewellery-copilot-chat";

const STORE = {
  name: "BlueBird Norte Shopping",
  address: "Rua Sara Afonso, nº105-117, Loja 0258, Piso 0, 4460-841",
  hours: "Todos os dias, das 10:00 às 23:00",
  // Store to store, from the coordinates of the store locator.
  nearby: ["BlueBird Mar Shopping (4,2 km)", "BlueBird Arrábida Shopping (4,7 km)", "BlueBird Gaia Shopping (7,5 km)"],
};

const ASK_ME = [
  "Esgotou aqui. Em que loja perto ainda há?",
  "Compara-me dois relógios Eco-Drive até 300 €",
  "O cliente quer trocar a pilha a este Citizen",
  "Um cliente quer aumentar um anel. Como faço?",
  "Como entrego um Click & Collect?",
  "Faz-me um teste sobre garantias",
];

function today() {
  return new Intl.DateTimeFormat("pt-PT", { weekday: "long", day: "numeric", month: "long" }).format(new Date());
}

function JewelleryCopilotPage() {
  useEffect(() => {
    document.title = "Portal da Loja · BlueBird Norte Shopping";
  }, []);
  useKodlyLoader(COPILOT_TOKEN, { mode: "docked", container: CONTAINER_ID });

  return (
    <div className="jcp-page">
      <header className="jcp-header">
        <div className="jcp-brand">
          <img className="jcp-logo" src={logo} alt="BlueBird" />
          <div className="jcp-divider" />
          <div>
            <div className="jcp-title">Portal da Loja</div>
            <div className="jcp-subtitle">{STORE.name}</div>
          </div>
        </div>
        <div className="jcp-meta">
          <span className="jcp-date">{today()}</span>
          <span className="jcp-demo">Demo</span>
        </div>
      </header>
      <main className="jcp-main">
        <aside className="jcp-rail">
          <section className="jcp-card">
            <h2>A tua loja</h2>
            <p className="jcp-strong">{STORE.name}</p>
            <p>{STORE.address}</p>
            <p>{STORE.hours}</p>
          </section>
          <section className="jcp-card">
            <h2>Lojas mais perto</h2>
            <ul>
              {STORE.nearby.map((store) => (
                <li key={store}>{store}</li>
              ))}
            </ul>
          </section>
          <section className="jcp-card jcp-card--accent">
            <h2>Pergunta ao Copiloto</h2>
            <ul>
              {ASK_ME.map((question) => (
                <li key={question}>{question}</li>
              ))}
            </ul>
            <p className="jcp-hint">Por escrito ou por mensagem de voz, em português ou noutra língua.</p>
          </section>
        </aside>
        <div id={CONTAINER_ID} className="jcp-chat" />
      </main>
      <footer className="jcp-footer">
        Demonstração Kodly. Produtos, preços, lojas, stock e políticas de bluebird.pt; procedimentos internos de exemplo.
      </footer>
    </div>
  );
}

export default JewelleryCopilotPage;
